<template>
  <div class="bg-blue-dark px-4 py-4 md:py-6">
    <FacetMenuCloseButton
      class="md:mt-3 mb-3"
    />
    <h4 class="text-white text-2xl font-bold">
      {{ translations.heading }}
    </h4>
  </div>
</template>

<script>
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import store from '@/components/facet/store'
import facetMenu from '@/components/facet/FacetTagMenu'
import FacetMenuCloseButton from '@/components/facet/FacetTagMenuCloseButton.vue'

const $root = document.querySelector('.js-facet-menu')
const $accordionRoot = document.querySelector('.js-facet-tag-menu-accordion')

export default {
  components: {
    FacetMenuCloseButton
  },
  props: {
    translations: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      store,
      isFirstTimeOpened: true
    }
  },
  watch: {
    'store.state.allFiltersVisible': {
      handler(value) {
        this.toggleMenuVisiblity(value)
      }
    }
  },
  mounted() {
    this.store.dispatch('setTranslations', { translations: this.translations })
  },
  methods: {
    toggleMenuVisiblity(value) {
      if (value) {
        $root.classList.add('is-opened')
        window.scrollTo(0, 0)
        disableBodyScroll($accordionRoot)
        if (this.isFirstTimeOpened) {
          this.isFirstTimeOpened = false
          facetMenu.initMainAccordion()
          facetMenu.initOverlayClick()
        }
      } else {
        $root.classList.add('is-closing')
        setTimeout(() => {
          $root.classList.remove('is-opened', 'is-closing')
          enableBodyScroll($accordionRoot)
        }, 300)
      }
    }
  }
}
</script>
